/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react";
import "./src/styles/global.css";
import { GatsbyBrowser } from "gatsby"

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return <>{element}</>;
};
